<template>
  <div class="container pb-2 pt-4">
    <h2
      v-if="data?.title"
      class="ui-text-xl mb-7.5 flex w-full justify-center font-normal not-italic text-black"
      :style="{ textAlign: data?.title_position || 'left' } as StyleValue"
    >
      <span class="block whitespace-pre-wrap text-center" v-html="data.title" />
    </h2>
    <p v-if="data?.subTitle" class="ui-text-m mb-7.5 text-center text-black">
      {{ data?.subTitle }}
    </p>
    <div class="flex justify-center">
      <UiButton
        v-if="data?.buttonUrl && data?.buttonLabel"
        :to="localePath(data?.buttonUrl)"
        variant="text"
        color="primary"
        content-class="font-bold underline text-black"
      >
        {{ data?.buttonLabel }}
      </UiButton>
    </div>
    <div class="mt-15 grid grid-cols-2 gap-5 lg:grid-cols-3">
      <BlocksCustomBlocksShopByStyleCard
        v-for="(item, idx) in data.slides"
        :key="idx"
        :data="item"
      />
    </div>
  </div>
</template>

<script setup lang="ts">
import { StyleValue } from "vue";
import { BlockSliderContent } from "~/types/api/block.types";

const localePath = useLocalePathPolyfill();

defineProps<{ data: BlockSliderContent }>();
</script>
